export default __webpack_public_path__ + "static/media/NFO_PostLogin_Consumption_Fund_Hero_Mobile.7251df4b.png";